/**
 * @generated SignedSource<<dc997c7cc5cfb5683f53e6ac29bd40ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageTitle_PageTreeTitleFragment$data = {
  readonly id: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "getCachedPageTitle_PageTreeTitleFragment";
};
export type getCachedPageTitle_PageTreeTitleFragment$key = {
  readonly " $data"?: getCachedPageTitle_PageTreeTitleFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageTitle_PageTreeTitleFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageTitle_PageTreeTitleFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    }
  ],
  "type": "PTPage"
};

(node as any).hash = "5ea3936d33c7a82bf109180867502c4b";

export default node;
